import {
    Card,
    CardHeader,
    CardBody,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Button,
    Col,
} from "reactstrap";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { httpRequest } from "utils/httpRequest";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom"

const AddLink = () => {
    const [link, setLink] = useState("");
    const [buttonLoading, setButtonLoading] = useState(false);

    const navigate = useNavigate()



    const validationSchema = Yup.object().shape({
        link: Yup.string().required("Link is required"),
    })



    const formik = useFormik({
        initialValues: {
            link: "",
        },
        validationSchema,
        onSubmit: async (values) => {
            formik.setTouched({
                link: true
            });

            const errors = await formik.validateForm(values);

            if (Object.keys(errors).length > 0) {
                console.log('Validation errors:', errors);
                return false;
            }
            setButtonLoading(true)
            try {


                const response = await httpRequest(
                    `resource/add`,
                    "POST",
                    {
                        link: values.link
                    },
                    {},
                    true,
                    true
                );

                if (response?.code === 200) {
                    toast.success("Resource Added Successfully")
                  
                    formik.resetForm({
                        values: {
                            link: "",
                        }
                    })

                    navigate("/admin/additional-resources")

                }

            } catch (error) {
                console.log(error);
               
            } finally {
                setButtonLoading(false)
            }


        }
    })


    return (
        <Col lg="6" md="8" className="mx-auto mt-5">
            <Card className="bg-secondary shadow border-0">
                <CardHeader className="bg-transparent pb-3">
                    <div className="text-muted text-center mt-2 mb-3">
                        <small>Add a Link</small>
                    </div>
                </CardHeader>
                <CardBody className="px-lg-5 py-lg-4">
                    <Form onSubmit={formik.handleSubmit}>
                        {/* Link Field */}
                        <FormGroup className="mb-4">
                            <label className="form-control-label">Link</label>
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-world" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    placeholder="Please Enter Link"
                                    type="url"
                                    value={formik.values.link}
                                    onChange={formik.handleChange}
                                    name="link"
                                    onBlur={formik.handleBlur}
                                />


                            </InputGroup>
                            {formik.touched.link && formik.errors.link ? (
                                <div className="text-danger small mt-1">{formik.errors.link}</div>
                            ) : null}
                        </FormGroup>

                        {/* Submit */}
                        <div className="text-center d-flex align-items-center justify-content-center">
                            <Button className="mb-3 d-flex align-items-center justify-content-center" color="primary" type="submit" disabled={buttonLoading}>
                                {buttonLoading ? <span className="button-loader"></span> : "Submit"}
                            </Button>

                        </div>
                    </Form>
                </CardBody>
            </Card>
        </Col>
    );
};

export default AddLink;
